// extracted by mini-css-extract-plugin
export default {"root":"SheetGroup_root__zZD1u","head":"SheetGroup_head__bkX3d","title":"SheetGroup_title__Y0v08","note":"SheetGroup_note__fihRX"};